import { useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { Icon } from '@/design-system/atoms/Icon'
import { Label } from '@/design-system/atoms/Label'
import { Input } from '@/design-system/atoms/Input'
import { Button } from '@/design-system/atoms/Button'
import { Alert } from '@/design-system/molecules/Alert'
import { authService } from '../../services/authService'

export default function ResetPasswordConfirmForm() {
  const [showPassword, setShowPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const navigate = useNavigate()
  const { uid, token } = useParams<{ uid: string; token: string }>()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')

    if (!password || !confirmPassword) {
      setError('Por favor, preencha todos os campos')
      return
    }

    if (password !== confirmPassword) {
      setError('As senhas não coincidem')
      return
    }

    if (password.length < 8) {
      setError('A senha deve ter pelo menos 8 caracteres')
      return
    }

    if (!uid || !token) {
      setError('Link inválido ou expirado')
      return
    }

    setIsLoading(true)

    try {
      await authService.confirmResetPassword(uid, token, password)
      navigate('/signin?message=password_reset_success')
    } catch {
      setError('Erro ao redefinir senha. O link pode estar expirado.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="flex flex-col flex-1">
      <div className="flex flex-col justify-center flex-1 w-full max-w-md mx-auto">
        <div>
          <div className="mb-5 sm:mb-8">
            <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
              Nova Senha
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Digite sua nova senha
            </p>
          </div>

          <div>
            <form onSubmit={handleSubmit}>
              {error && (
                <Alert variant="error" className="mb-4">
                  {error}
                </Alert>
              )}

              <div className="space-y-6">
                <div>
                  <Label>
                    Nova Senha <span className="text-error-500">*</span>
                  </Label>
                  <div className="relative">
                    <Input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Digite sua nova senha"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      disabled={isLoading}
                      required
                    />
                    <span
                      onClick={() => setShowPassword(!showPassword)}
                      className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                    >
                      {showPassword ? (
                        <Icon
                          name="eye"
                          size={20}
                          className="text-gray-500 dark:text-gray-400"
                        />
                      ) : (
                        <Icon
                          name="eye-off"
                          size={20}
                          className="text-gray-500 dark:text-gray-400"
                        />
                      )}
                    </span>
                  </div>
                </div>

                <div>
                  <Label>
                    Confirmar Senha <span className="text-error-500">*</span>
                  </Label>
                  <div className="relative">
                    <Input
                      type={showConfirmPassword ? 'text' : 'password'}
                      placeholder="Confirme sua nova senha"
                      value={confirmPassword}
                      onChange={e => setConfirmPassword(e.target.value)}
                      disabled={isLoading}
                      required
                    />
                    <span
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                      className="absolute z-30 -translate-y-1/2 cursor-pointer right-4 top-1/2"
                    >
                      {showConfirmPassword ? (
                        <Icon
                          name="eye"
                          size={20}
                          className="text-gray-500 dark:text-gray-400"
                        />
                      ) : (
                        <Icon
                          name="eye-off"
                          size={20}
                          className="text-gray-500 dark:text-gray-400"
                        />
                      )}
                    </span>
                  </div>
                </div>

                <div>
                  <Button
                    type="submit"
                    className="w-full"
                    size="sm"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Salvando...' : 'Redefinir Senha'}
                  </Button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}
